const Sales = () => {
    return ( 
        <div>
            <h2>Sales</h2>
            <p>Welcome to the Sales!</p>
        </div>
     );
}
 
export default Sales;